<div class="conference-container">
    <div *ngIf="showOverlay()"
         class="overlay" 
         [@fadeVisibility]="overlayState()"
         (@fadeVisibility.done)="onOverlayAnimationDone($event)">
      @let errorMessage = error();
      @if (errorMessage) {
        <div class="alert alert-danger d-flex flex-column align-items-center justify-content-center">
          <span class="error">{{ errorMessage }}</span>
          <div class="actions">
            <button cButton color="secondary" (click)="onCancel()">Cancel</button>
            <button cButton color="primary" (click)="onRetry()">Reload</button>
          </div>
        </div>
      } @else {
        <spinner [text]="'conference.zoom.loading'"></spinner>
      }
    </div>
    
    <iframe
      #iframe
      *ngIf="iframeUrl"
      [src]="iframeUrl"
      title="Zoom Meeting"
      [@fadeVisibility]="iframeState()"
      allow="camera; microphone; display-capture; fullscreen; autoplay; clipboard-read; clipboard-write; speaker-selection; compute-pressure"
      allowfullscreen
      referrerpolicy="origin"
      ></iframe>
      @if (!joined()) {
        <button cButtonClose (click)="close()"></button>
      }
  </div>